import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable } from 'rxjs';
import { GlobalErrorService } from '@services/global-error.service';
import { ProfileValidationService } from '@services/profile-validation.service';
import {
  Candidate,
  CandidatesResponse,
  UploadResponse,
  SkillResponse,
  ValidateProfilePayload,
  ValidateProfileResponse,
} from './add-candidate.model';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AddCandidateService {
  private baseUrl = environment.apiUrl;
  private fileUploadUrl = environment.fileUploadApiUrl;
  constructor(
    private http: HttpClient,
    private errorHandler: GlobalErrorService,
    private profileValidationService: ProfileValidationService
  ) {}

  getCandidateInfo(candidateId: string): Observable<CandidatesResponse> {
    return this.http
      .get<CandidatesResponse>(
        `${this.baseUrl}/hiring/candidate/${candidateId}`
      )
      .pipe(
        catchError((error) => {
          return this.errorHandler.logError(error);
        })
      );
  }

  updateCandidateInfo(candidateData: Candidate): Observable<Candidate> {
    const url = `${this.baseUrl}/vendor/candidate`;
    return this.http.put<Candidate>(url, candidateData).pipe(
      catchError((error) => {
        return this.errorHandler.logError(error);
      })
    );
  }
  
  addCandidateInfo(candidateData: Candidate): Observable<Candidate> {
    return this.http
      .post<Candidate>(`${this.baseUrl}/hiring/candidate`, candidateData)
      .pipe(
        catchError((error) => {
          return this.errorHandler.logError(error);
        })
      );
  }
  getSkillData(): Observable<SkillResponse> {
    return this.http.get<SkillResponse>(`${this.baseUrl}/hiring/skills`).pipe(
      catchError((error) => {
        return this.errorHandler.logError(error);
      })
    );
  }

  validateProfile(payload: ValidateProfilePayload): Observable<ValidateProfileResponse> {
    return this.profileValidationService.validateProfile(payload);
  }
}
